import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import * as DocumentManagement from "../DocumentManagement";
import { DocumentStoreImpl } from "../Stores/DocumentStore";
import { Strings } from "../Stores/StringsStore";

interface IInputDocumentLinkComponentProps {
	model: DocumentManagement.InputDocumentLink;
	selectedLanguage: string;
	documentStore: DocumentStoreImpl;
	onUpdateValue: () => void;
	onChange?: () => void;
	onClick?: () => void;
	testId?: string;
}

@observer
export class InputDocumentLinkComponent extends React.Component<IInputDocumentLinkComponentProps, {}> {
	render() {
		return <InputDocumentLinkComponentInternal value={this.props.model.value} isValid={this.props.model.isValid} validationMessage={this.props.model.validationMessage} {...this.props} />
	}
}

interface IInputDocumentLinkComponentPropsInternal {
	value: string;
	isValid: boolean;
	validationMessage: string;
	selectedLanguage: string;
	documentStore: DocumentStoreImpl;
	onUpdateValue: () => void;
	onChange?: () => void;
	onClick?: () => void;
	testId?: string;
}

@observer
class InputDocumentLinkComponentInternal extends React.Component<IInputDocumentLinkComponentPropsInternal, {}> {

	@observable documentName: string;

	componentWillMount() {
		this.updateValue(this.props.value);
	}

	componentWillReceiveProps(nextProps: IInputDocumentLinkComponentPropsInternal) {
		this.updateValue(nextProps.value);
		this.props.onUpdateValue();
	}

	updateValue = (value: string) => {
		if (value) {
			let query = new DocumentManagement.DocumentDetailsQuery();
			query.guid = value;
			query.language = this.props.selectedLanguage;
			DocumentManagement.getDocumentAsync(query).then(result => {
				this.documentName = result.isNew ? Strings.documentManagement.documentEdit.metasDocumentDeleted : result.name.value;
			});
		}
		else {
			this.documentName = null;
		}
	}

	onClick = () => {
		this.props.documentStore.metaDataSelectDocumentsWizardStore.open();
		this.props.onClick();
	}

	render() {
		let input = <div onClick={this.onClick} data-test-id={this.props.testId} className={"documentLinkValue" + (!this.props.isValid ? " is--input-invalid" : "")}>
			{this.documentName ? this.documentName : this.props.value}
		</div>;
		let message = this.props.validationMessage ? <span className="is--validation-note">{this.props.validationMessage}</span> : null;
		return <label>
			{input}
			{message}
		</label>;
	}
}